import React, { useState } from 'react';
import { Search, Plus, SquarePen, Trash2 } from 'lucide-react';
import '../styles/DataTable.css';

/**
 * Tabla genérica del prototipo. La usan Créditos y Catálogos, que todavía
 * operan contra la API en memoria.
 *
 * Clientes ya NO la usa: su listado está en pages/Clientes.js porque
 * necesita paginación de servidor, filtros, menú de acciones y vista de
 * tarjetas. Cuando Créditos y Catálogos migren a base de datos habrá que
 * decidir si comparten aquella implementación o se retira este componente.
 */
function DataTable({ columns, data, onEdit, onDelete, onAdd, addLabel = 'Nuevo' }) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <div className="datatable-container">
      <div className="datatable-toolbar">
        <div className="datatable-search">
          <Search size={16} strokeWidth={1.75} className="datatable-search-icon" />
          <input
            type="search"
            placeholder="Buscar en la lista"
            aria-label="Buscar registros"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <button className="btn btn-primary datatable-add" onClick={onAdd}>
          <Plus size={16} strokeWidth={2} />
          {addLabel}
        </button>
      </div>

      <div className="datatable-wrapper">
        <table className="datatable">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
              <th className="th-actions">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item) => (
                <tr key={item.id}>
                  {columns.map((col) => (
                    <td key={col.key}>{item[col.key]}</td>
                  ))}
                  <td className="actions-cell">
                    <button
                      className="btn btn-icon"
                      onClick={() => onEdit(item)}
                      aria-label="Editar registro"
                      title="Editar"
                    >
                      <SquarePen size={16} strokeWidth={1.75} />
                    </button>
                    <button
                      className="btn btn-icon is-danger"
                      onClick={() => onDelete(item.id)}
                      aria-label="Eliminar registro"
                      title="Eliminar"
                    >
                      <Trash2 size={16} strokeWidth={1.75} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length + 1} className="no-data">
                  {searchTerm
                    ? `Ningún registro coincide con "${searchTerm}".`
                    : 'Aún no hay registros. Crea el primero.'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DataTable;
